/**
 * Get global namespaces
 */
export const getIS = () => { var _a; return (_a = window.sznIVA) === null || _a === void 0 ? void 0 : _a.IS; };
export const getISconfig = () => { var _a; return (_a = window.sznIVA) === null || _a === void 0 ? void 0 : _a.ISConfig; };
/**
 * Initial State object (for example propagated from site BE, to hydrate IS on FE)
 */
export const getInitialState = () => window.__SZN_IS_INITIAL_STATE__;
export const cleanupInitialState = () => delete window.__SZN_IS_INITIAL_STATE__;
